import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';

@Injectable()
export class SubIdInterceptor implements HttpInterceptor {
  private route = inject(ActivatedRoute);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('Subscription-Id') ||
      req.url.includes('storage.googleapis')
    ) {
      return next.handle(
        req.clone({
          url: `${req.url}`,
        }),
      );
    } else {
      return this.route.queryParams.pipe(
        map((params) => params['subscription_id']),
        exhaustMap((subscription_id) => {
          const modifiedReq = req.clone({
            headers: req.headers.set('Subscription-Id', subscription_id ?? ''),
          });
          return next.handle(modifiedReq);
        }),
      );
    }
  }
}
